import { Box, Link, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { loginPage } from '@/constants/loginPage';

const footerLinks = [
  {
    key: 'loginFooterCreditsafeGlobal',
    href: 'https://www.creditsafe.com',
  },
  {
    key: 'loginFooterPrivacyPolicy',
    href: 'https://www.creditsafe.com/us/en/legal/privacy-policy.html',
  },
  {
    key: 'loginFooterSecurityStandards',
    href: 'https://www.creditsafe.com/us/en/legal.html',
  },
] as const;

export function LoginFooter() {
  const { t } = useTranslation('entity-portal');

  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        maxWidth: loginPage.cardWidth,
        mx: 'auto',
        textAlign: 'center',
      }}
    >
      <Stack
        direction="row"
        spacing={{ xs: 1.5, sm: 2.5 }}
        justifyContent="center"
        alignItems="center"
        useFlexGap
        flexWrap="wrap"
        sx={{ mb: 1.25 }}
      >
        {footerLinks.map((link) => (
          <Link
            key={link.key}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            variant="subtitle2"
            sx={{
              color: 'text.secondary',
              '&:focus-visible': {
                outline: '2px solid',
                outlineColor: 'primary.main',
                outlineOffset: 2,
                borderRadius: 0.5,
              },
            }}
          >
            {t(link.key)}
          </Link>
        ))}
      </Stack>

      <Typography variant="caption" sx={{ color: 'text.disabled' }}>
        {t('login.loginFooterCopyright')}
      </Typography>
    </Box>
  );
}
